"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-installment-loan.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-installment-loan.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.installmentLoanTypeToJSON = exports.installmentLoanTypeFromJSON = exports.loanPaymentMethodToJSON = exports.loanPaymentMethodFromJSON = exports.InstallmentLoanPaymentContextLoanPayments = exports.InstallmentLoanPaymentContextLoanPayment = exports.InstallmentLoanPaymentContextLoanFunding = exports.InstallmentLoanPaymentContext = exports.InstallmentLoanType = exports.LoanPaymentMethod = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.common.proto';
var LoanPaymentMethod;
(function (LoanPaymentMethod) {
    LoanPaymentMethod["METHOD_NOT_SET"] = "METHOD_NOT_SET";
    LoanPaymentMethod["MANUAL_PAYMENT"] = "MANUAL_PAYMENT";
    LoanPaymentMethod["INITIAL_AUTO_PAY"] = "INITIAL_AUTO_PAY";
    LoanPaymentMethod["DAILY_AUTO_PAY_RETRY"] = "DAILY_AUTO_PAY_RETRY";
    LoanPaymentMethod["JIT_AUTO_PAY"] = "JIT_AUTO_PAY";
    LoanPaymentMethod["ACCOUNT_CLOSURE_PAYMENT"] = "ACCOUNT_CLOSURE_PAYMENT";
    LoanPaymentMethod["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LoanPaymentMethod || (exports.LoanPaymentMethod = LoanPaymentMethod = {}));
var InstallmentLoanType;
(function (InstallmentLoanType) {
    InstallmentLoanType["INVALID_INSTALLMENT_LOAN_TYPE"] = "INVALID_INSTALLMENT_LOAN_TYPE";
    InstallmentLoanType["PURCHASE_LOAN"] = "PURCHASE_LOAN";
    InstallmentLoanType["BORROW_CASH_LOAN"] = "BORROW_CASH_LOAN";
    InstallmentLoanType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstallmentLoanType || (exports.InstallmentLoanType = InstallmentLoanType = {}));
function createBaseInstallmentLoanPaymentContext() {
    return {
        accountId: '',
        funding: undefined,
        payment: undefined,
        payments: undefined,
        loanName: '',
        installmentsCount: 0,
        loanType: InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE,
        loanTotal: undefined,
    };
}
exports.InstallmentLoanPaymentContext = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (isSet(object.funding)) {
            message.funding = exports.InstallmentLoanPaymentContextLoanFunding.fromJSON(object.funding);
        }
        if (isSet(object.payment)) {
            message.payment = exports.InstallmentLoanPaymentContextLoanPayment.fromJSON(object.payment);
        }
        if (isSet(object.payments)) {
            message.payments = exports.InstallmentLoanPaymentContextLoanPayments.fromJSON(object.payments);
        }
        if (isSet(object.loanName)) {
            message.loanName = globalThis.String(object.loanName);
        }
        if (isSet(object.installmentsCount)) {
            message.installmentsCount = globalThis.Number(object.installmentsCount);
        }
        if (isSet(object.loanType)) {
            message.loanType = installmentLoanTypeFromJSON(object.loanType);
        }
        if (isSet(object.loanTotal)) {
            message.loanTotal = amount_1.Amount.fromJSON(object.loanTotal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.funding !== undefined) {
            obj.funding = exports.InstallmentLoanPaymentContextLoanFunding.toJSON(message.funding);
        }
        if (message.payment !== undefined) {
            obj.payment = exports.InstallmentLoanPaymentContextLoanPayment.toJSON(message.payment);
        }
        if (message.payments !== undefined) {
            obj.payments = exports.InstallmentLoanPaymentContextLoanPayments.toJSON(message.payments);
        }
        if (message.loanName !== undefined && message.loanName !== '') {
            obj.loanName = message.loanName;
        }
        if (message.installmentsCount !== undefined && message.installmentsCount !== 0) {
            obj.installmentsCount = Math.round(message.installmentsCount);
        }
        if (message.loanType !== undefined &&
            message.loanType !== InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE) {
            obj.loanType = installmentLoanTypeToJSON(message.loanType);
        }
        if (message.loanTotal !== undefined) {
            obj.loanTotal = amount_1.Amount.toJSON(message.loanTotal);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanPaymentContext();
        message.accountId = object.accountId ?? '';
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? exports.InstallmentLoanPaymentContextLoanFunding.fromPartial(object.funding)
            : undefined;
        message.payment = (object.payment !== undefined && object.payment !== null)
            ? exports.InstallmentLoanPaymentContextLoanPayment.fromPartial(object.payment)
            : undefined;
        message.payments = (object.payments !== undefined && object.payments !== null)
            ? exports.InstallmentLoanPaymentContextLoanPayments.fromPartial(object.payments)
            : undefined;
        message.loanName = object.loanName ?? '';
        message.installmentsCount = object.installmentsCount ?? 0;
        message.loanType = object.loanType ?? InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE;
        message.loanTotal = (object.loanTotal !== undefined && object.loanTotal !== null)
            ? amount_1.Amount.fromPartial(object.loanTotal)
            : undefined;
        return message;
    },
};
function createBaseInstallmentLoanPaymentContextLoanFunding() {
    return {};
}
exports.InstallmentLoanPaymentContextLoanFunding = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPaymentContextLoanFunding.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseInstallmentLoanPaymentContextLoanFunding();
        return message;
    },
};
function createBaseInstallmentLoanPaymentContextLoanPayment() {
    return { installmentId: '', installmentIndex: 0 };
}
exports.InstallmentLoanPaymentContextLoanPayment = {
    fromJSON(object) {
        const message = {
            installmentId: isSet(object.installmentId) ? globalThis.String(object.installmentId) : '',
            installmentIndex: isSet(object.installmentIndex)
                ? globalThis.Number(object.installmentIndex)
                : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.installmentId !== '') {
            obj.installmentId = message.installmentId;
        }
        if (message.installmentIndex !== 0) {
            obj.installmentIndex = Math.round(message.installmentIndex);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPaymentContextLoanPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanPaymentContextLoanPayment();
        message.installmentId = object.installmentId ?? '';
        message.installmentIndex = object.installmentIndex ?? 0;
        return message;
    },
};
function createBaseInstallmentLoanPaymentContextLoanPayments() {
    return {
        payments: [],
        manualPayment: false,
        intendedAmount: undefined,
        paymentMethod: LoanPaymentMethod.METHOD_NOT_SET,
    };
}
exports.InstallmentLoanPaymentContextLoanPayments = {
    fromJSON(object) {
        const message = {
            payments: globalThis.Array.isArray(object?.payments)
                ? object.payments.map((e) => exports.InstallmentLoanPaymentContextLoanPayment.fromJSON(e))
                : [],
            manualPayment: isSet(object.manualPayment) ? globalThis.Boolean(object.manualPayment) : false,
        };
        if (isSet(object.intendedAmount)) {
            message.intendedAmount = amount_1.Amount.fromJSON(object.intendedAmount);
        }
        if (isSet(object.paymentMethod)) {
            message.paymentMethod = loanPaymentMethodFromJSON(object.paymentMethod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.payments?.length) {
            obj.payments = message.payments.map((e) => exports.InstallmentLoanPaymentContextLoanPayment.toJSON(e));
        }
        if (message.manualPayment !== false) {
            obj.manualPayment = message.manualPayment;
        }
        if (message.intendedAmount !== undefined) {
            obj.intendedAmount = amount_1.Amount.toJSON(message.intendedAmount);
        }
        if (message.paymentMethod !== undefined &&
            message.paymentMethod !== LoanPaymentMethod.METHOD_NOT_SET) {
            obj.paymentMethod = loanPaymentMethodToJSON(message.paymentMethod);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPaymentContextLoanPayments.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanPaymentContextLoanPayments();
        message.payments =
            object.payments?.map((e) => exports.InstallmentLoanPaymentContextLoanPayment.fromPartial(e)) || [];
        message.manualPayment = object.manualPayment ?? false;
        message.intendedAmount = (object.intendedAmount !== undefined && object.intendedAmount !== null)
            ? amount_1.Amount.fromPartial(object.intendedAmount)
            : undefined;
        message.paymentMethod = object.paymentMethod ?? LoanPaymentMethod.METHOD_NOT_SET;
        return message;
    },
};
function loanPaymentMethodFromJSON(object) {
    switch (object) {
        case 0:
        case 'METHOD_NOT_SET':
            return LoanPaymentMethod.METHOD_NOT_SET;
        case 1:
        case 'MANUAL_PAYMENT':
            return LoanPaymentMethod.MANUAL_PAYMENT;
        case 2:
        case 'INITIAL_AUTO_PAY':
            return LoanPaymentMethod.INITIAL_AUTO_PAY;
        case 3:
        case 'DAILY_AUTO_PAY_RETRY':
            return LoanPaymentMethod.DAILY_AUTO_PAY_RETRY;
        case 4:
        case 'JIT_AUTO_PAY':
            return LoanPaymentMethod.JIT_AUTO_PAY;
        case 5:
        case 'ACCOUNT_CLOSURE_PAYMENT':
            return LoanPaymentMethod.ACCOUNT_CLOSURE_PAYMENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LoanPaymentMethod.UNRECOGNIZED;
    }
}
exports.loanPaymentMethodFromJSON = loanPaymentMethodFromJSON;
function loanPaymentMethodToJSON(object) {
    switch (object) {
        case LoanPaymentMethod.METHOD_NOT_SET:
            return 'METHOD_NOT_SET';
        case LoanPaymentMethod.MANUAL_PAYMENT:
            return 'MANUAL_PAYMENT';
        case LoanPaymentMethod.INITIAL_AUTO_PAY:
            return 'INITIAL_AUTO_PAY';
        case LoanPaymentMethod.DAILY_AUTO_PAY_RETRY:
            return 'DAILY_AUTO_PAY_RETRY';
        case LoanPaymentMethod.JIT_AUTO_PAY:
            return 'JIT_AUTO_PAY';
        case LoanPaymentMethod.ACCOUNT_CLOSURE_PAYMENT:
            return 'ACCOUNT_CLOSURE_PAYMENT';
        case LoanPaymentMethod.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.loanPaymentMethodToJSON = loanPaymentMethodToJSON;
function installmentLoanTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INSTALLMENT_LOAN_TYPE':
            return InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE;
        case 1:
        case 'PURCHASE_LOAN':
            return InstallmentLoanType.PURCHASE_LOAN;
        case 2:
        case 'BORROW_CASH_LOAN':
            return InstallmentLoanType.BORROW_CASH_LOAN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstallmentLoanType.UNRECOGNIZED;
    }
}
exports.installmentLoanTypeFromJSON = installmentLoanTypeFromJSON;
function installmentLoanTypeToJSON(object) {
    switch (object) {
        case InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE:
            return 'INVALID_INSTALLMENT_LOAN_TYPE';
        case InstallmentLoanType.PURCHASE_LOAN:
            return 'PURCHASE_LOAN';
        case InstallmentLoanType.BORROW_CASH_LOAN:
            return 'BORROW_CASH_LOAN';
        case InstallmentLoanType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.installmentLoanTypeToJSON = installmentLoanTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-installment-loan.js.map